<template>
  <div id="head">
    <div class="block-left">
      <div class="logo dib vam lhz" @click="goBack">
        <img class="main-logo" :src="Logo" />
      </div>
      <div class="dib vam">
        <area-select />
      </div>
    </div>
    <div class="block-right">
      <div class="dib vam lhz">
        <div class="searchPad">
          <search />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import AreaSelect from './area-select';
  import Search from './search';
  import Logo from 'Assets/images/logo.png';
  import EventSystem from '../utils/EventSystem';

  export default {
    components: {
      AreaSelect,
      Search,
    },
    // Vars
    props: {},
    data() {
      return {
        Logo,
      };
    },

    // Lifecyle
    created() {},

    // Methods
    computed: {},
    methods: {
      goBack() {
        EventSystem.$emit('go-back-to-first-screen-why---cause-they-said-so');
      }
    },
  };
</script>





// WEBPACK FOOTER //
// assets/js/source/vue-ui/head.vue